// src/components/admin/AdminContactsDirectorySection.tsx
import { requireSupabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";
import { AdminContactsDirectoryContent } from "./AdminContactsDirectoryContent";
import { useAdminContactsDirectoryState } from "./useAdminContactsDirectoryState";
import { useAdminContactsDirectoryViewModel } from "./useAdminContactsDirectoryViewModel";

type Props = {
  organizationId: string;
  onToast?: (message: string, variant?: "ok" | "err") => void;
};

export function AdminContactsDirectorySection({ organizationId, onToast }: Props) {
  const auth = useAuth();
  const sb = requireSupabase();
  const state = useAdminContactsDirectoryState();
  const vm = useAdminContactsDirectoryViewModel({
    organizationId,
    sb,
    authToken: auth.session?.access_token,
    onToast,
    state,
  });
  return <AdminContactsDirectoryContent {...vm} />;
}
